import { createFileRoute } from '@tanstack/react-router';
import OrganizationDocuments from '@uturn/portal/modules/org/pages/documents';

export const Route = createFileRoute(
	'/_protected/org/$orgId/settings/documents/',
)({
	component: OrganizationDocuments,
});
